import React from "react";
import styles from "./callbotBackendError.module.css";

const CallbotBackendError = ({ errors }) => {
  return (
    <div className={styles.error_container}>
      {typeof errors === "string" ? (
        <div>{errors}</div>
      ) : typeof (errors === "object") ? (
        <div>
          <div>
            Error message:
            <b> {errors.original_error}</b>
          </div>
          <br className={styles.line_separator} />
          <div>State name: {errors.state_name?.split("-")[0]}</div>
          <br className={styles.line_separator} />
          <div>Module class: {errors.module_class}</div>
          <br className={styles.line_separator} />
          <div>Module name: {errors.module_name}</div>
          <br className={styles.line_separator} />
          <div>Error type: {errors.error_name}</div>
        </div>
      ) : (
        <div />
      )}
    </div>
  );
};

export default CallbotBackendError;
